/**
 * Helper to reliably get millis from any plausible createdAt value
 * @param {*} createdAt
 * @returns
 */
export default function getMillis(createdAt) {
  if (!createdAt) return 0;
  // Firestore Timestamp object
  if (typeof createdAt.toMillis === "function") return createdAt.toMillis();
  // Date object
  if (createdAt instanceof Date) return createdAt.getTime();
  // Firestore _seconds (as in DocumentSnapshots)
  if (typeof createdAt._seconds === "number") return createdAt._seconds * 1000;
  // Native JS timestamp as number
  if (typeof createdAt === "number") return createdAt;
  // Fallback: sometimes serverTimestamp() returns { nanoseconds, seconds }
  if (typeof createdAt.seconds === "number") return createdAt.seconds * 1000;
  return 0;
}
